var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "_indexPage"
  }, [_c('reflection-index')], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };